import FunctionsIcon from '@mui/icons-material/Functions';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Grid,
    IconButton,
    Paper,
    TextField,
    Typography
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { toPriceString } from '../../utils';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const MarkupCalculator = () => {
    const [markup, setMarkup] = useState(0);
    const [margin, setMargin] = useState(0);
    const [markupText, setMarkupText] = useState('');

    useEffect(() => {
        setMarkup(Number(markupText.replace(',', '.')) / 100);
    }, [markupText, setMarkup]);

    const calculateMargin = useCallback(() => {
        const calculatedMargin = markup / 100 / (1 + markup);
        setMargin(calculatedMargin * 100);
    }, [markup]);

    return (
        <Paper sx={{ marginTop: 2 }}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography sx={theme => ({ fontSize: theme.typography.pxToRem(15) })}>
                        Calculate margin from markup
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container direction="column" justifyContent="flex-start" spacing={2}>
                        <Grid item>
                            <TextField
                                placeholder="Markup %"
                                onChange={event => setMarkupText(event.target.value)}
                            />
                            <IconButton disabled={markup === 0} onClick={() => calculateMargin()}>
                                <FunctionsIcon />
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <Typography variant="body2" gutterBottom>
                                <strong>Margin: </strong> {toPriceString(margin * 100)}
                            </Typography>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </Paper>
    );
};
